/* eslint-disable indent */
// export const domainIssues: any = {
//     'www.kaggle.com': [
//         'Google auth doesn\'t works',
//     ],
//     'olacabs.com': [
//         'Invalid response for few netowrk request',
//         'Outdated SSL certificate'
//     ],
//     'uber.com': [
//         'Graphql queries only supported',
//         'Search functionality issues'
//     ],
//     'dev.reclaimprotocol.org': [
//         'Graphql queries only supported',
//         'Search functionality issues'
//     ]
// }

export const domainIssues: any = {};
